import React from "react";

const Promotion1 = () => {
  const handleClick = () => {
    window.open("https://fivespot.io/", "_blank");
  };

  return (
    <div
      className="flex w-full justify-center bg-white text-[#1F2937]"
      style={{
        fontFamily: "Pretendard",
      }}
    >
      <section className="flex w-full flex-col pb-24">
        {/* hero */}
        <div className="px-[60px] 800r:px-[10px] flex flex-col bg-[#5E6EFF] pb-[100px] pt-[200px] 800r:pb-[60px] 800r:pt-[140px]">
          <div className="flex flex-row 1200r:flex-col max-w-[1080px] mx-auto w-full">
            <div className="flex flex-col pb-[30px]">
              <div className="flex flex-row 800r:flex-col 800r:gap-y-[10px] gap-x-[14px] items-center 1200r:mx-auto">
                <img
                  className="mb-[4px] h-[18px]"
                  src="/assets/promotion/2/saveoffice-logo-white.svg"
                  alt=""
                />
                <img
                  className="w-[14px] h-[14px]"
                  src="/assets/promotion/2/x.svg"
                  alt=""
                />
                <img
                  className="w-[94px] h-[14px] 800r:mt-[4px]"
                  src="/assets/promotion/2/fivespot_logo.svg"
                  alt=""
                />
              </div>
              <div className="text-left 1200r:text-center text-[62px] leading-[80px] text-white font-[800] mt-[10px] 1200r:mt-[30px] 800r:mt-[40px] 800r:text-[30px] 800r:leading-[40px]">
                대표님의 비즈니스 성장
                <br />두 배 도와줄 공간
              </div>
              <div className="text-left 1200r:text-center text-[28px] leading-[38px] text-white font-[400] mt-[40px] 800r:mt-[30px] 800r:text-[16px] 800r:leading-[24px]">
                파이브스팟 4시간 패스 무료 쿠폰과
                <br />
                모든 패스 15% 할인 쿠폰 받아 가세요!
              </div>
            </div>
            <img
              className="w-[332px] h-[220px] 800r:w-auto 800r:h-[140px] ml-auto mt-auto 1200r:mx-auto 1200r:mt-[40px]"
              src="/assets/promotion/2/hero.png"
              alt=""
            />
          </div>
        </div>

        {/* intro */}
        <div className="flex flex-col max-w-[1080px] w-full mx-auto pt-[175px] pb-[150px] 800r:pt-[60px] 800r:pb-[80px] text-center">
          <div className="text-[36px] font-[700] leading-[52px] text-[#2B2B2B] 800r:text-[16px] 800r:leading-[26px]">
            국내 NO.1 비상주 사무실
            <br />
            <span className="text-[#5E6EFF]">세이브오피스</span>와
          </div>
          <div className="text-[36px] font-[700] leading-[52px] text-[#2B2B2B] mt-[30px] 800r:text-[16px] 800r:leading-[26px]">
            공유 오피스 NO.1 패스트파이브가 만든
            <br />
            워크 라운지 플랫폼{" "}
            <span className="text-[#FF5900]">파이브스팟</span>이
            <br />
            만났습니다.
          </div>
          <div className="text-[22px] font-[400] leading-[40px] text-[#2B2B2B] mt-[30px] 800r:text-[14px] 800r:leading-[26px]">
            파이브스팟은 서울 주요 입지에 위치한 <br className="800:hidden" />
            워크 라운지 플랫폼입니다.
            <br />
            공부, 독서, 노트북 작업 등 몰입의 시간을 위한{" "}
            <br className="800:hidden" />
            최적의 공간을 제공합니다.
          </div>
          <div className="flex flex-row 1200r:flex-col 1200r:gap-y-[20px] gap-x-[24px] items-center mt-[90px] 800r:mt-[40px] mx-auto">
            <img
              className="w-[360px] h-[240px] 800r:w-auto 800r:h-[200px]"
              src="/assets/promotion/2/box1.png"
              alt=""
            />
            <img
              className="w-[30px] h-[30px] 800r:w-[20px] 800r:h-[20px]"
              src="/assets/promotion/2/plus.svg"
              alt=""
            />
            <img
              className="w-[360px] h-[240px] 800r:w-auto 800r:h-[200px]"
              src="/assets/promotion/2/box2.png"
              alt=""
            />
          </div>

          <div className="flex flex-col mt-[90px] 800r:mt-[40px]">
            <div className="text-center justify-start text-zinc-800 text-4xl font-bold font-['Pretendard'] leading-[50px] 800r:text-[16px] 800r:leading-[26px]">
              세이브오피스 한정
            </div>
            <div className="text-center justify-start mt-[20px]">
              <span className="text-zinc-800 text-3xl font-bold font-['Pretendard'] leading-[48px] 800r:text-[16px] 800r:leading-[26px] bg-[linear-gradient(to_bottom,transparent_60%,#C5CBFF_60%)] bg-[length:100%_100%] bg-no-repeat">
                비상주 사무실 주소 서비스
              </span>
              <span className="text-zinc-800 text-3xl font-normal font-['Pretendard'] leading-[48px] 800r:text-[16px] 800r:leading-[26px]">
                와 <br className="800:hidden" />
              </span>
              <span className="text-zinc-800 text-3xl font-bold font-['Pretendard'] leading-[48px] 800r:text-[16px] 800r:leading-[26px] bg-[linear-gradient(to_bottom,transparent_60%,#C5CBFF_60%)] bg-[length:100%_100%] bg-no-repeat">
                장소 제공
              </span>
              <span className="text-zinc-800 text-3xl font-normal font-['Pretendard'] leading-[48px] 800r:text-[16px] 800r:leading-[26px]">
                까지 다 드리는
                <br />
                다신 없을 혜택을 지금 바로 확인해 보세요!
              </span>
            </div>
          </div>
        </div>

        {/* featured reasons */}
        <div className="w-full bg-[#EEF4FF]">
          <div className="flex flex-col pt-[110px] pb-[120px] 800r:py-[60px] max-w-[1080px] w-full mx-auto">
            <div className="text-[28px] font-[500] leading-[50px] text-[#2B2B2B] 800r:text-[20px]">
              1인 사업자가
            </div>
            <div className="text-[42px] font-[700] leading-[62px] text-[#5E6EFF] 800r:text-[20px] 800r:leading-[20px]">
              파이브스팟을 이용해야 하는 이유
            </div>
            <div className="mx-auto mt-[60px] 800r:mt-[40px] grid grid-cols-1 gap-[20px] 800:grid-cols-2">
              {reasonCards.map((card) => (
                <article
                  key={card.alt}
                  className="w-[460px] h-[260px] 800r:w-[300px] 800r:h-[170px] bg-white flex flex-row rounded-[28px] 800r:rounded-[20px]"
                >
                  <div className="flex flex-col py-[50px] pl-[30px] 800r:py-[20px] 800r:pl-[20px] text-left">
                    <div className="bg-[#F0F0F0] py-[4px] px-[10px] 800r:py-[2px] 800r:px-[8px] rounded-full w-fit">
                      <div className="text-[14px] 800r:text-[10px] font-[500] leading-[14px] text-[#9A9A9A] text-center mx-auto translate-y-[1px]">
                        {card.tag}
                      </div>
                    </div>
                    <div className="text-[16px] leading-[26px] text-[#7C7C7C] mt-[8px] 800r:text-[12px] 800r:leading-[20px]">
                      {card.title}
                    </div>
                    <div className="text-[24px] font-[600] leading-[34px] text-[#2B2B2B] mt-[12px] 800r:text-[16px] 800r:leading-[24px]">
                      {card.description}
                    </div>
                  </div>
                  <img
                    src={card.img}
                    alt={card.alt}
                    className="w-[218px] h-[260px] 800r:w-auto 800r:h-[170px] ml-auto"
                    loading="lazy"
                  />
                </article>
              ))}
            </div>
          </div>
        </div>

        {/* benefits */}
        <div className="py-[140px] 800r:py-[60px] max-w-[1080px] w-full mx-auto flex flex-col">
          <div className="text-[42px] font-[700] leading-[62px] text-[#5E6EFF] 800r:text-[20px]">
            세이브오피스 고객 전용 혜택
          </div>
          <div className="text-[24px] font-[400] leading-[38px] text-[#2B2B2B] mt-[10px] 800r:text-[14px] 800r:leading-[24px]">
            세이브오피스 비상주 사무실로 주소 등록하고
            <br />
            파이브스팟 240여개 라운지를 <br className="800:hidden" />
            할인가로 이용해 보세요.
          </div>
          <div className="flex flex-row 1200r:flex-col 1200r:gap-y-[20px] mx-auto mt-[66px] 800r:mt-[40px] gap-x-[20px]">
            <div className="w-[440px] h-[380px] 800r:w-[260px] 800r:h-[230px] rounded-[20px] border-[1px] border-[#D0D0D0] flex flex-col">
              <div className="text-[20px] font-[600] leading-[30px] text-[#5E6EFF] mt-[60px] 800r:mt-[20px] 800r:text-[14px]">
                파이브스팟 직영점
              </div>
              <div className="text-[32px] font-[700] leading-[46px] text-[#2B2B2B] mt-[4px] 800r:text-[20px] 800r:leading-[30px]">
                4시간 이용 무료 쿠폰
              </div>
              <div className="bg-[#EEF4FF] rounded-full px-[10px] py-[2px] w-fit mx-auto mt-[24px] 800r:mt-[10px]">
                <div className="text-[16px] font-[500] leading-[26px] text-[#075DFE] 800r:text-[10px] 800r:leading-[20px]">
                  발급 기간
                </div>
              </div>
              <div className="text-[20px] font-[400] leading-[30px] text-[#2B2B2B] mt-[6px] 800r:text-[14px] 800r:leading-[20px]">
                25.09.01 ~ 25.12.31
              </div>
              <div className="bg-[#EEF4FF] rounded-full px-[10px] py-[2px] w-fit mx-auto mt-[20px] 800r:mt-[10px]">
                <div className="text-[16px] font-[500] leading-[26px] text-[#075DFE] 800r:text-[10px] 800r:leading-[20px]">
                  사용처
                </div>
              </div>
              <div className="text-[20px] font-[400] leading-[30px] text-[#2B2B2B] mt-[6px] 800r:text-[14px] 800r:leading-[20px]">
                파이브스팟 직영 44개 지점
              </div>
            </div>
            <div className="w-[440px] h-[380px] 800r:w-[260px] 800r:h-[230px] rounded-[20px] border-[1px] border-[#D0D0D0] flex flex-col">
              <div className="text-[20px] font-[600] leading-[30px] text-[#5E6EFF] mt-[60px] 800r:mt-[20px] 800r:text-[14px]">
                파이브스팟 직영점
              </div>
              <div className="text-[32px] font-[700] leading-[46px] text-[#2B2B2B] mt-[4px] 800r:text-[20px] 800r:leading-[30px]">
                모든 패스 15% 할인쿠폰
              </div>
              <div className="bg-[#EEF4FF] rounded-full px-[10px] py-[2px] w-fit mx-auto mt-[24px] 800r:mt-[10px]">
                <div className="text-[16px] font-[500] leading-[26px] text-[#075DFE] 800r:text-[10px] 800r:leading-[20px]">
                  발급 기간
                </div>
              </div>
              <div className="text-[20px] font-[400] leading-[30px] text-[#2B2B2B] mt-[6px] 800r:text-[14px] 800r:leading-[20px]">
                25.09.01 ~ 25.12.31
              </div>
              <div className="bg-[#EEF4FF] rounded-full px-[10px] py-[2px] w-fit mx-auto mt-[20px] 800r:mt-[10px]">
                <div className="text-[16px] font-[500] leading-[26px] text-[#075DFE] 800r:text-[10px] 800r:leading-[20px]">
                  사용처
                </div>
              </div>
              <div className="text-[20px] font-[400] leading-[30px] text-[#2B2B2B] mt-[6px] 800r:text-[14px] 800r:leading-[20px]">
                파이브스팟 전국 240여 개 지점
              </div>
            </div>
          </div>
          <div className="mt-[28px] text-[20px] font-[400] leading-[32px] text-[#7C7C7C] 800r:text-[16px]">
            세이브오피스 계약하는 고객분들에게 <br className="800:hidden" />
            파이브스팟 쿠폰 코드 발송해 드립니다.
            <br />
            받으신 쿠폰은 파이브스팟에 쿠폰 등록하여{" "}
            <br className="800:hidden" />
            사용하시기 바랍니다.
          </div>
          <div
            className="w-[400px] h-[80px] 800r:w-[300px] 800r:h-[50px] rounded-full bg-[#7D7D7D] cursor-pointer flex mx-auto mt-[60px] 800r:mt-[40px]"
            onClick={handleClick}
          >
            <div className="mx-auto my-auto text-[22px] font-[600] leading-[30px] text-white 800r:text-[16px]">
              파이브스팟 쿠폰 등록하기
            </div>
          </div>
        </div>

        <picture className="w-full max-w-[1920px] mx-auto block">
          <source
            srcSet="/assets/promotion/guide-avif.avif"
            type="image/avif"
          />
          <img
            src="/assets/promotion/guide.png"
            alt="파이브스팟 이용 가이드"
            className="w-full h-auto"
            loading="lazy"
          />
        </picture>

        {/* notes */}
        <div className="w-full bg-[#F5F5F5] pt-[70px] pb-[110px] 800r:py-[60px]">
          <div className="w-full max-w-[1080px] mx-auto flex flex-col text-left px-[70px] 800r:px-[20px] text-[#7C7C7C] text-[20px] font-[400] leading-[32px] 800r:text-[14px] 800r:leading-[22px]">
            <div className="font-[600] leading-[30px]">유의사항</div>
            <div className="mt-[20px]">
              •본 프로모션은 세이브오피스 고객 대상 혜택입니다.
            </div>
            <div className="mt-[20px]">
              <span className="font-[600]">파이브스팟 이용 안내</span>
              <br />
              파이브스팟 쿠폰은 파이브스팟 앱에서 사용 가능합니다.
            </div>
            <div className="mt-[10px]">
              STEP 1) 파이브스팟 홈페이지 또는 앱 설치 후 회원 가입을 먼저
              진행해 주세요.
              <br />▶{" "}
              <span className="underline">
                <a
                  href="https://apps.apple.com/kr/app/%ED%8C%8C%EC%9D%B4%EB%B8%8C%EC%8A%A4%ED%8C%9F/id6479978558"
                  target="_blank"
                  rel="noreferrer"
                >
                  파이브스팟 어플 다운로드 받기
                </a>
              </span>{" "}
              :{" "}
              <span className="underline">
                <a
                  href="https://fivespace.app.link"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://fivespace.app.link
                </a>
              </span>
            </div>
            <div className="mt-[20px]">
              STEP 2) 더 보기 {">"} 쿠폰 메뉴에서 {">"} 쿠폰 코드를 입력하고
              쿠폰을 등록하세요.
              <br />
              STEP 3) 패스 사용하기 {">"} 패스 무료 쿠폰 : 이용할 패스 {">"}{" "}
              기간형 or시간형 {">"} 이용할 패스 1회 선택 후 결제 단계에서 쿠폰을
              적용해 주세요.
              <br />
              STEP 4) 파이브스팟 이용하기{" "}
              <span className="underline">
                <a
                  href="https://fivespot.io/event/check-in"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://fivespot.io/event/check-in
                </a>
              </span>
            </div>
            <div className="mt-[20px]">
              ※ 기간형 패스 : 전국 전 지점 (직영점, 제휴 지점) 모두에서 사용
              가능합니다.
              <br />※ 시간 패스 무료 쿠폰 : 1인 1매만 사용 가능하며, 시간형
              패스는 파이브스팟 직영점 44개 지점에서만 사용 가능합니다.
            </div>
            <div className="font-[600] mt-[60px]">
              패스트 파이브 파이브스팟 이용권 사용 유의사항
            </div>
            <div className="mt-[20px]">
              • 이용권 사용 유의사항은 발행 기관의 정책을 따릅니다.
              <br />
              • 이용권 관련한 궁금하신 점은 파이브스팟 이용방법을 이용해 주시면
              더욱 자세히 확인하실 수 있습니다.
              <br />
              ▶ 
              <span className="underline">
                <a
                  href="https://fivespot.oopy.io/wiki"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://fivespot.oopy.io/wiki
                </a>
              </span>
            </div>
            <div className="mt-[50px]">
              • 본 프로모션은 당사 사정에 따라 사전 공지 없이 변경되거나 종료될
              수 있습니다.
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

type ReasonCard = {
  tag: string;
  title: React.ReactNode;
  description: React.ReactNode;
  img: string;
  alt: string;
};

const reasonCards: ReasonCard[] = [
  {
    tag: "첫째",
    title: (
      <>
        240개 이상
        <br />
        압도적인 지점 수
      </>
    ),
    description: (
      <>
        어디서나
        <br />
        걸어서 5분
      </>
    ),
    img: "/assets/promotion/2/1.png",
    alt: "",
  },
  {
    tag: "둘째",
    title: (
      <>
        호텔 라운지 같은
        <br />
        압도적인 공간 퀄리티
      </>
    ),
    description: (
      <>
        365일 24시간
        <br />
        운영하는 라운지
      </>
    ),
    img: "/assets/promotion/2/2.png",
    alt: "",
  },
  {
    tag: "셋째",
    title: (
      <>
        업무 및
        <br />
        자기 계발에 최적
      </>
    ),
    description: (
      <>
        각자 일에 집중하는
        <br />
        생산적인 분위기
      </>
    ),
    img: "/assets/promotion/2/3.png",
    alt: "",
  },
  {
    tag: "넷째",
    title: (
      <>
        라운지에서
        <br />
        무제한으로 즐기는
      </>
    ),
    description: (
      <>
        커피&씨리얼
        <br />
        프린트도 무료
      </>
    ),
    img: "/assets/promotion/2/4.png",
    alt: "",
  },
];

export default Promotion1;
